<section class="time-series">
  <article class="time-series-channel">
    <canvas class="time-series-canvas"></canvas>
  </article>
</section>